module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/th/2/4-4dabd915201074afd01b15c329098552.jpg";